<script>
import { OrderStatus } from '@/enums/OrderStatus'
import CheckoutOpen from './open/CheckoutOpen.vue'
import CheckoutPending from '@/components/checkout/pending/CheckoutPending.vue'
export default {
  name: 'Checkout',
  components: {
    CheckoutOpen,
    CheckoutPending
  },
  props: {
    order: { type: Object },
    nextStep: { type: Function }
  },
  data() {
    return {
      orderStatus: OrderStatus
    }
  },
  created() {
    // argument is cms api-endpoint
    this.$cmsService
      .fetchContent('checkoutContents')
      .then(response => {
        if (response !== '') this.content = response
      })
      .catch(() => {})
  }
}
</script>
<template>
  <div>
    <CheckoutOpen
      v-if="
        order.orderStatus === orderStatus.paymentOpen ||
        orderStatus.paymentRefused
      "
      :order="order"
      :next-step="nextStep"
    />
    <CheckoutPending
      v-if="order.orderStatus === orderStatus.paymentPending"
      :order="order"
    />
  </div>
</template>
